import { render, staticRenderFns } from "./RecommendationFilter.vue?vue&type=template&id=7b5b82fe"
import script from "./RecommendationFilter.vue?vue&type=script&lang=js"
export * from "./RecommendationFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports